import { css } from "@emotion/css";

import { ButtonGroup, GhostIconButton } from "@certn/cascadia-react";

import { NavigationBar } from "./NavigationBar";
import { StepType } from "../../stepper/ActivityStepper";
import { ProgressStepperHorizontal } from "../../stepper/ProgressStepperHorizontal";
import { mq } from "../../utils";

interface SecondaryNavWithStepperProps {
  testID: string;
  children?: React.ReactNode;
  stepperSteps: StepType[];
  handleClose?: () => void;
  handlePrevStep?: () => void;
  currentStepIndex: number;
}

export function SecondaryTopNavWithStepper(
  props: SecondaryNavWithStepperProps
) {
  const {
    testID,
    children,
    stepperSteps,
    handleClose,
    handlePrevStep,
    currentStepIndex,
  } = props;

  return (
    <NavigationBar testID={props.testID}>
      {currentStepIndex === 0 ? (
        <GhostIconButton
          icon="close"
          size="medium"
          testID={`${testID}-close`}
          onPress={handleClose}
        />
      ) : (
        <GhostIconButton
          icon="arrow_back"
          size="medium"
          testID={`${testID}-arrow_back`}
          onPress={handlePrevStep}
        />
      )}
      <div className={styles.stepperContainer}>
        <ProgressStepperHorizontal
          steps={stepperSteps}
          currentStepIndex={currentStepIndex}
          containerWidth="640px"
        />
      </div>
      <ButtonGroup justify="end">{children}</ButtonGroup>
    </NavigationBar>
  );
}

const styles = {
  stepperContainer: css(
    {
      alignItems: "center",
      justifyContent: "center",
      left: 0,
      marginLeft: "200px",
      marginRight: "200px",
      position: "absolute",
      right: 0,
      pointerEvents: "none",
    },
    mq({ display: ["none", "none", "flex"] })
  ),
};
